"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPersonCount2OrMoreCustomConditional = exports.accessCodeIsSetCustomConditional = exports.shouldAskForNoSchoolTripSpecifyCustomConditional = exports.shouldAskForNoSchoolTripReasonCustomConditional = exports.shouldAskPersonNoWorkTripSpecifyCustomConditional = exports.shouldAskForNoWorkTripReasonCustomConditional = exports.shouldAskTripJunctionCustomConditional = exports.shouldDisplayOnDemandTypeCustomConditional = exports.isSelfDeclaredCarDriverCustomConditional = exports.isCarDriverAndDestinationWorkCustomConditional = exports.alreadyVisitedPlaceCustomConditional = exports.isLastPlaceCustomConditional = exports.currentPlaceWorkOnTheRoadAndNoNextPlaceCustomConditional = exports.departurePlaceOtherCustomConditional = exports.personUsualSchoolPlaceNameCustomConditional = exports.personOccupationCustomConditional = exports.hiddenWithCanadaAsDefaultValueCustomConditional = exports.hiddenWithQuebecAsDefaultValueCustomConditional = void 0;
const get_1 = __importDefault(require("lodash/get"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const types_1 = require("evolution-common/lib/services/odSurvey/types");
const customFrontendHelper_1 = require("./customFrontendHelper");
const helper_1 = require("./helper");
const customHelpers_1 = require("./customHelpers");
const isSchoolEnrolledTrueValues = [
    'kindergarten',
    'childcare',
    'primarySchool',
    'secondarySchool',
    'schoolAtHome',
    'other'
];
// Don't show Question and give 'Québec' as default value
const hiddenWithQuebecAsDefaultValueCustomConditional = (_interview) => {
    return [false, 'Québec'];
};
exports.hiddenWithQuebecAsDefaultValueCustomConditional = hiddenWithQuebecAsDefaultValueCustomConditional;
// Don't show Question and give 'Canada' as default value
const hiddenWithCanadaAsDefaultValueCustomConditional = (_interview) => {
    return [false, 'Canada'];
};
exports.hiddenWithCanadaAsDefaultValueCustomConditional = hiddenWithCanadaAsDefaultValueCustomConditional;
// Stay hidden and put some default value if the person is a student or a worker
const personOccupationCustomConditional = (interview, path) => {
    const person = surveyHelper.getResponse(interview, path, null, '../');
    const age = surveyHelper.getResponse(interview, path, null, '../age');
    const schoolType = surveyHelper.getResponse(interview, path, null, '../schoolType');
    const isStudent = person.studentType === 'fullTime' || person.studentType === 'partTime';
    const isWorker = person.workerType === 'fullTime' || person.workerType === 'partTime';
    if ((0, LodashExtensions_1._isBlank)(age) || (0, LodashExtensions_1._isBlank)(person.workerType) || (0, LodashExtensions_1._isBlank)(person.studentType)) {
        return [false, null];
    }
    else if (isStudent && isWorker) {
        return [false, 'workerAndStudent'];
    }
    else if (isStudent && person.studentType === 'fullTime') {
        return [false, 'fullTimeStudent'];
    }
    else if (isStudent && person.studentType === 'partTime') {
        return [false, 'partTimeStudent'];
    }
    else if (isWorker && person.workerType === 'fullTime') {
        return [false, 'fullTimeWorker'];
    }
    else if (isWorker && person.workerType === 'partTime') {
        return [false, 'partTimeWorker'];
    }
    else if (schoolType && !isSchoolEnrolledTrueValues.includes(schoolType)) {
        return [false, 'other'];
    }
    //condition if not hidden choices
    return [!(0, LodashExtensions_1._isBlank)(age) && age >= 14 && !isStudent && !isWorker, null];
};
exports.personOccupationCustomConditional = personOccupationCustomConditional;
const personUsualSchoolPlaceNameCustomConditional = (interview, path) => {
    const person = surveyHelper.getResponse(interview, path, null, '../../');
    const schoolPlaceType = person.schoolPlaceType;
    const childrenCase = (0, customHelpers_1.isStudentFromEnrolled)(person) && person.schoolType !== 'schoolAtHome';
    return [['onLocation', 'hybrid'].includes(schoolPlaceType) || childrenCase, null];
};
exports.personUsualSchoolPlaceNameCustomConditional = personUsualSchoolPlaceNameCustomConditional;
const departurePlaceOtherCustomConditional = (interview, path) => {
    const journey = odSurveyHelper.getActiveJourney({ interview });
    if (journey === null) {
        return [false, null];
    }
    const personDidTrips = journey.personDidTrips;
    const personDidTripsConfirm = journey.personDidTripsConfirm;
    const firstVisitedPlace = odSurveyHelper.getVisitedPlacesArray({
        journey
    })[0];
    const departurePlaceOther = journey.departurePlaceOther;
    if (firstVisitedPlace && firstVisitedPlace.activity && firstVisitedPlace.activity !== 'home') {
        // FIXME should we make sure the departurePlaceOther is one of he possible choices? We have something similar in the `onSectionEntry` of the tripsIntro section... maybe we don't need this here
        return [false, departurePlaceOther];
    }
    return [
        ((0, LodashExtensions_1._booleish)(personDidTrips) || (0, LodashExtensions_1._booleish)(personDidTripsConfirm)) &&
            !(0, LodashExtensions_1._isBlank)(journey.departurePlaceIsHome) &&
            (0, LodashExtensions_1._booleish)(journey.departurePlaceIsHome) === false,
        null
    ];
};
exports.departurePlaceOtherCustomConditional = departurePlaceOtherCustomConditional;
const currentPlaceWorkOnTheRoadAndNoNextPlaceCustomConditional = (interview, path) => {
    const person = odSurveyHelper.getPerson({ interview });
    const journey = odSurveyHelper.getActiveJourney({ interview, person });
    const visitedPlace = surveyHelper.getResponse(interview, path, null, '../');
    const visitedPlaceActivity = visitedPlace.activity;
    const nextVisitedPlace = odSurveyHelper.getNextVisitedPlace({ journey, visitedPlaceId: visitedPlace._uuid });
    return [!nextVisitedPlace && visitedPlaceActivity === 'workOnTheRoad', null];
};
exports.currentPlaceWorkOnTheRoadAndNoNextPlaceCustomConditional = currentPlaceWorkOnTheRoadAndNoNextPlaceCustomConditional;
const isLastPlaceCustomConditional = (interview, path) => {
    const person = odSurveyHelper.getPerson({ interview });
    const journey = odSurveyHelper.getActiveJourney({ interview, person });
    const visitedPlace = odSurveyHelper.getActiveVisitedPlace({ interview, journey });
    const visitedPlacesArray = odSurveyHelper.getVisitedPlacesArray({ journey });
    return (visitedPlacesArray.length > 1 && visitedPlacesArray[visitedPlacesArray.length - 1]._uuid === visitedPlace._uuid);
};
exports.isLastPlaceCustomConditional = isLastPlaceCustomConditional;
const alreadyVisitedPlaceCustomConditional = (interview, path) => {
    const activity = surveyHelper.getResponse(interview, path, null, '../activity');
    // Do not display if no activity
    if ((0, LodashExtensions_1._isBlank)(activity)) {
        return [false, null];
    }
    // Do not display if it is an incompatible activity
    const incompatibleActivity = [...types_1.loopActivities, 'home'].includes(activity);
    if (incompatibleActivity) {
        return [false, null];
    }
    // Do not display if usual place is already set
    const person = odSurveyHelper.getPerson({ interview });
    if ((activity === 'workUsual' && person.usualWorkPlace && person.usualWorkPlace.geography) ||
        (activity === 'schoolUsual' && person.usualSchoolPlace && person.usualSchoolPlace.geography)) {
        return [false, null];
    }
    // Display if there are possible shortcuts
    const geography = surveyHelper.getResponse(interview, path, null, '../geography');
    let lastAction = null;
    if (geography) {
        lastAction = (0, get_1.default)(geography, 'properties.lastAction', null);
    }
    const shortcuts = (0, customFrontendHelper_1.getShortcutVisitedPlaces)(interview);
    return [(lastAction === null || lastAction === 'shortcut') && shortcuts.length > 0, null];
};
exports.alreadyVisitedPlaceCustomConditional = alreadyVisitedPlaceCustomConditional;
const isCarDriverAndDestinationWorkCustomConditional = (interview, path) => {
    const segment = surveyHelper.getResponse(interview, path, null, '../');
    const modePre = segment ? segment.modePre : null;
    const person = odSurveyHelper.getPerson({ interview });
    const trip = odSurveyHelper.getActiveTrip({ interview });
    const journey = odSurveyHelper.getActiveJourney({ interview, person });
    const visitedPlaces = odSurveyHelper.getVisitedPlaces({ journey });
    const destination = odSurveyHelper.getDestination({ visitedPlaces, trip });
    return [modePre === 'carDriver' && destination.activityCategory === 'work', null];
};
exports.isCarDriverAndDestinationWorkCustomConditional = isCarDriverAndDestinationWorkCustomConditional;
const peopleCountQuestionModes = ['carDriver', 'rentalCar', 'carDriverCarsharing'];
const isSelfDeclaredCarDriverCustomConditional = (interview, path) => {
    const segment = surveyHelper.getResponse(interview, path, null, '../');
    // Display for respondent car drivers (exlude motorcycle)
    if (segment.modePre !== 'carDriver') {
        return [false, null];
    }
    const person = odSurveyHelper.getActivePerson({ interview });
    return [
        odSurveyHelper.isSelfDeclared({ interview, person }) && peopleCountQuestionModes.includes(segment.mode),
        null
    ];
};
exports.isSelfDeclaredCarDriverCustomConditional = isSelfDeclaredCarDriverCustomConditional;
// Show if mode is transitTaxi, or if mode is transitBus (and not nationale variant) and busLines include 'dontKnow' or 'other'.
const shouldDisplayOnDemandTypeCustomConditional = (interview, path) => {
    const mode = surveyHelper.getResponse(interview, path, null, '../mode');
    const busLines = surveyHelper.getResponse(interview, path, [], '../busLines');
    const isNotNationale = process.env.EV_VARIANT !== 'nationale'; // Check if EV_VARIANT is not 'nationale'
    // Show if mode is transitTaxi, or if mode is transitBus (and not nationale variant) and busLines include 'dontKnow' or 'other'.
    const shouldDisplay = mode === 'transitTaxi' ||
        (isNotNationale &&
            mode === 'transitBus' &&
            busLines.length > 0 &&
            (busLines.includes('dontKnow') || busLines.includes('other')));
    return [shouldDisplay, null];
};
exports.shouldDisplayOnDemandTypeCustomConditional = shouldDisplayOnDemandTypeCustomConditional;
const shouldAskTripJunctionCustomConditional = (interview, path) => {
    const person = odSurveyHelper.getPerson({ interview });
    const trip = odSurveyHelper.getActiveTrip({ interview });
    if (trip) {
        const journey = odSurveyHelper.getActiveJourney({ interview, person });
        const visitedPlaces = odSurveyHelper.getVisitedPlaces({ journey });
        const destination = odSurveyHelper.getDestination({ visitedPlaces, trip });
        const activity = destination ? destination.activity : null;
        const segments = odSurveyHelper.getSegmentsArray({ trip });
        const currentSegment = surveyHelper.getResponse(interview, path, undefined, '../');
        const segmentIndex = segments.findIndex((segment) => segment._sequence === (currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment._sequence));
        if (segmentIndex === undefined || segmentIndex === 0) {
            return [false, null];
        }
        const previousSegment = segments[segmentIndex - 1];
        return [(0, helper_1.shouldDisplayTripJunction)(previousSegment, currentSegment, activity), null];
    }
    return [false, null];
};
exports.shouldAskTripJunctionCustomConditional = shouldAskTripJunctionCustomConditional;
const shouldAskForNoWorkTripReasonCustomConditional = (interview, path) => {
    const person = odSurveyHelper.getPerson({ interview, path });
    return [(0, helper_1.shouldAskForNoWorkTripReason)({ interview, person }), null];
};
exports.shouldAskForNoWorkTripReasonCustomConditional = shouldAskForNoWorkTripReasonCustomConditional;
const shouldAskPersonNoWorkTripSpecifyCustomConditional = (interview, path) => {
    const reason = surveyHelper.getResponse(interview, path, null, '../noWorkTripReason');
    return [reason === 'other', null];
};
exports.shouldAskPersonNoWorkTripSpecifyCustomConditional = shouldAskPersonNoWorkTripSpecifyCustomConditional;
const shouldAskForNoSchoolTripReasonCustomConditional = (interview, path) => {
    const person = odSurveyHelper.getPerson({ interview, path });
    return [(0, helper_1.shouldAskForNoSchoolTripReason)({ interview, person }), null];
};
exports.shouldAskForNoSchoolTripReasonCustomConditional = shouldAskForNoSchoolTripReasonCustomConditional;
const shouldAskForNoSchoolTripSpecifyCustomConditional = (interview, path) => {
    const reason = surveyHelper.getResponse(interview, path, null, '../noSchoolTripReason');
    return [reason === 'other', null];
};
exports.shouldAskForNoSchoolTripSpecifyCustomConditional = shouldAskForNoSchoolTripSpecifyCustomConditional;
const accessCodeIsSetCustomConditional = (interview, path) => {
    // Do not show the access code if it is set and confirmed, but keep its value, to avoid the participant changing its value
    const accessCodeConfirmed = surveyHelper.getResponse(interview, '_accessCodeConfirmed', false);
    const accessCode = surveyHelper.getResponse(interview, path, null);
    return [!accessCodeConfirmed, accessCode];
};
exports.accessCodeIsSetCustomConditional = accessCodeIsSetCustomConditional;
// FIXME This conditional is used instead of the non custom
// `hasHouseholdSize2OrMoreConditional` because the person count can change in
// the household section without changing the household size. When
// https://github.com/chairemobilite/evolution/issues/1132 is fixed and this
// survey correctly updated, this custom conditional won't be necessary
const hasPersonCount2OrMoreCustomConditional = (interview, path) => {
    const personCount = odSurveyHelper.countPersons({ interview });
    return [personCount >= 2, null];
};
exports.hasPersonCount2OrMoreCustomConditional = hasPersonCount2OrMoreCustomConditional;
